export default __webpack_public_path__ + "assets/images/bef6e03718cd890e0541170472cf7c28.svg";